import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from "react";
import { SettingsDialog } from "@/components/settings/settings-dialog";

type SettingsValue = { open: () => void };

const SettingsContext = createContext<SettingsValue | null>(null);

/** One Settings dialog for the whole app; the gear buttons and the ad slots open it. */
export function SettingsProvider({ children }: { children: ReactNode }) {
  const [isOpen, setOpen] = useState(false);
  const open = useCallback(() => setOpen(true), []);
  const value = useMemo(() => ({ open }), [open]);
  return (
    <SettingsContext.Provider value={value}>
      {children}
      <SettingsDialog open={isOpen} onOpenChange={setOpen} />
    </SettingsContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useSettingsDialog(): SettingsValue {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error("useSettingsDialog must be used inside <SettingsProvider>");
  return ctx;
}
